import { render, staticRenderFns } from "./TabSubstitute.vue?vue&type=template&id=629c6bda"
import script from "./TabSubstitute.vue?vue&type=script&lang=js"
export * from "./TabSubstitute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports